import { render, staticRenderFns } from "./SubEmpresaTabelaGestaoAlvorada.vue?vue&type=template&id=56e21390&lang=pug"
import script from "./SubEmpresaTabelaGestaoAlvorada.vue?vue&type=script&lang=js"
export * from "./SubEmpresaTabelaGestaoAlvorada.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaTabelaGestaoAlvorada.vue?vue&type=style&index=0&id=56e21390&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports